// extracted by mini-css-extract-plugin
export default {"breadcrumbsRow":"Dp-z","selected":"Ep-z"};